/** Hand-authored mechanics; procedural miniature seeds come directly from stable IDs. */
export type Effect = 'none' | 'bond' | 'banner' | 'raid' | 'scribe' | 'muster';
export interface CardDef { id: string; family: 'cat' | 'hare' | 'snail' | 'goose'; power: number; lane: 0 | 1 | 'any'; effect: Effect; rare: boolean }
const families = ['cat', 'hare', 'snail', 'goose'] as const;
const roles: Array<{ power: number; lane: 0 | 1 | 'any'; effect: Effect }> = [
  { power: 5, lane: 0, effect: 'none' }, { power: 3, lane: 'any', effect: 'bond' },
  { power: 3, lane: 1, effect: 'raid' }, { power: 2, lane: 'any', effect: 'banner' },
  { power: 2, lane: 1, effect: 'scribe' }, { power: 3, lane: 0, effect: 'muster' },
];
export const CARD_POOL: readonly CardDef[] = families.flatMap(family => roles.map((role, i) => ({ id: `${family}_${i}`, family, ...role, rare: i >= 4 })));
export const STARTER_OWNED = CARD_POOL.filter(c => Number(c.id.slice(-1)) < 4).map(c => c.id);
export const STARTER_DECK = STARTER_OWNED.filter(id => !id.startsWith('goose'));
